import { render, staticRenderFns } from "./BuildingSettingsPage.vue?vue&type=template&id=3019e5e7&scoped=true&"
import script from "./BuildingSettingsPage.vue?vue&type=script&lang=js&"
export * from "./BuildingSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019e5e7",
  null
  
)

export default component.exports